let rolloutFlags: Record<string, boolean> = {};

const isRolloutFlagEnabled = (key: string) => {
  return rolloutFlags[key] ?? false;
};

const rolloutFlagsSetup = (userProfile: { rollout_flags: Record<string, boolean> }) => {
  rolloutFlags = { ...userProfile?.rollout_flags };
};

export { isRolloutFlagEnabled, rolloutFlagsSetup };
